const SESSION_TOKEN_KEY = 'skipdq_session_token';
const LEGACY_SESSION_TOKEN_KEY = 'trucktime_session_token';

export function getSessionToken() {
  const current = localStorage.getItem(SESSION_TOKEN_KEY);
  if (current) return current;
  const legacy = localStorage.getItem(LEGACY_SESSION_TOKEN_KEY);
  if (legacy) {
    localStorage.setItem(SESSION_TOKEN_KEY, legacy);
    localStorage.removeItem(LEGACY_SESSION_TOKEN_KEY);
    return legacy;
  }
  return '';
}

export function setSessionToken(token) {
  if (!token) return;
  localStorage.setItem(SESSION_TOKEN_KEY, token);
  localStorage.removeItem(LEGACY_SESSION_TOKEN_KEY);
}

export function clearSessionToken() {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(LEGACY_SESSION_TOKEN_KEY);
}

export async function apiFetch(path, options = {}) {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const token = getSessionToken();
  const headers = new Headers(options.headers || {});

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return fetch(`${baseUrl}${path}`, {
    ...options,
    headers,
    credentials: 'include',
  });
}
